// src/lib/query/cacheVersion.ts
/**
 * @fileoverview Cache versioning for React Query persistence
 *
 * Increment CACHE_VERSION when:
 * - UserData interface changes
 * - Any persisted data structure changes
 * - Query key structure changes
 */

/**
 * Cache version - increment on schema changes
 * Format: YYYYMMDD.X where X is revision number
 */
export const CACHE_VERSION = '20260203.1';

/**
 * Checks if stored cache version matches current version
 */
export const isCacheVersionValid = (): boolean => {
  try {
    const storedVersion = localStorage.getItem('rq-cache-version');
    return storedVersion === CACHE_VERSION;
  } catch {
    return false;
  }
};

/**
 * Updates the stored cache version
 */
export const updateCacheVersion = (): void => {
  try {
    localStorage.setItem('rq-cache-version', CACHE_VERSION);
  } catch (error) {
    console.warn('[CacheVersion] Failed to update cache version:', error);
  }
};

/**
 * Clears all persisted cache when version mismatch detected
 */
export const clearStaleCache = (): void => {
  try {
    const keys = Object.keys(localStorage);
    keys.forEach(key => {
      if (key.startsWith('rq-cache-') || key.startsWith('REACT_QUERY_')) {
        localStorage.removeItem(key);
      }
    });
    updateCacheVersion();
  } catch (error) {
    console.warn('[CacheVersion] Failed to clear stale cache:', error);
  }
};
